export const findBikeDistanceScore = (bikeID, distanceStore) => {
    for (var i=0; i < distanceStore.length; i++) {
        if (distanceStore[i].id === bikeID) {
            return Math.ceil(distanceStore[i].distance * 10) / 10;
        }
    }
}